export default {"id":"2e4a66e0","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}